export default {
  common: {
    bingWallpaper: 'Bing壁紙',
    home: 'ホーム',
    about: 'について',
    blog: 'ブログ',
    refresh: 'ページ更新',
    loading: '読み込み中...',
    year: '年',
    preview: 'プレビュー',
    close: '閉じる',
    today: '今日',
    yesterday: '昨日',
    dayBefore: '一昨日',
    daysAgo: '日前',
    monthsAgo: 'ヶ月前',
    yearsAgo: '年前',
    unknown: '不明',
    copySuccess: 'クリップボードにコピーしました',
    copyFail: 'コピーに失敗しました。手動でコピーしてください',
    language: '言語',
    chinese: '中文',
    english: 'English',
    visitorCount: 'あなたは第 {count} 人目の訪問者です',
    copyright: '当サイトの画像はすべてBing検索からのものです。学習および個人使用のみに限定されています',
    footerCopyright: 'Copyright © 2022 - {year}',
    openMenu: 'メニューを開く',
    fatalError: 'ページの読み込みに失敗しました。更新して再試行してください',
    regionChina: '中国',
    regionGermany: 'ドイツ',
    regionCanada: 'カナダ',
    regionUK: 'イギリス',
    regionIndia: 'インド',
    regionUS: 'アメリカ',
    regionFrance: 'フランス',
    regionItaly: 'イタリア',
    regionJapan: '日本',
    netdiskQuark: 'Quarkドライブ',
    netdiskAlipan: 'Alipanドライブ',
    downloadViaNetdisk: 'HD壁紙をダウンロード',
    use: '経由'
  },
  wallpaper: {
    siteTitle: 'Bing壁紙 - Microsoft Bing デイリーHD壁紙ダウンロード',
    siteDesc: 'Bing壁紙ダウンロードサイト。毎日{strong}Microsoft Bing{/strong}公式デイリー壁紙を同期更新。{strong}中国、アメリカ、日本、ドイツ、イギリス、フランス、イタリア、カナダ、インド{/strong}など各国のBing壁紙を閲覧・ダウンロードできます。{strong}4K、1920x1080、1920x1200、1366x768{/strong}など多种解像度に対応。年別フィルターで{strong}一括ダウンロード{/strong}可能。すべてのHD壁紙は無料でダウンロードできます。デスクトップやスマートフォンの壁紙に最適です。',
    regionFilter: '地域',
    resolutionFilter: '解像度',
    yearFilter: '年',
    selectRegion: '地域を選択',
    selectResolution: 'サイズを選択',
    selectYear: '年を選択',
    yearHint: '年を選択するとその年の壁紙を一括ダウンロードできます',
    currentFilter: '現在のフィルター',
    totalWallpapers: '{count} 枚の壁紙',
    batchDownload: '一括ダウンロード',
    downloadingWallpapers: '壁紙をダウンロード中...',
    packaging: 'パッケージ中...',
    downloadSuccess: '{count} 枚の壁紙をダウンロードしました',
    downloadFailed: '一括ダウンロードに失敗しました。再試行してください',
    noWallpapers: 'ダウンロード可能な壁紙がありません',
    noResults: '条件に一致する壁紙が見つかりません',
    clearFilters: 'フィルターをクリア',
    filterRegion: '地域',
    filterYear: '年',
    filterResolution: 'サイズ',
    fetchFailed: '壁紙データの取得に失敗しました',
    fetchFailedNetwork: '壁紙データの取得に失敗しました。ネットワークを確認してください',
    unknownError: '不明なエラー',
    yearSuffix: '年'
  },
  detail: {
    viewOriginal: '元画像を表示',
    backHome: 'ホームに戻る',
    downloadWallpaper: 'ダウンロード',
    copyLink: 'リンクをコピー',
    viewFullscreen: '全画面表示',
    fullscreenTooltip: '壁紙画像をクリックすると全画面表示できます',
    imageDescription: '説明',
    viewSource: '出典を表示',
    openOriginal: '元画像を開く',
    copyrightInfo: '著作権',
    publishDate: '日付',
    switchResolution: '解像度を切り替え',
    recommended: 'その他の壁紙',
    loadingDetail: '壁紙詳細を読み込み中...',
    loadFailed: '読み込み失敗',
    reload: '再試行',
    loadingImage: '画像を読み込み中...',
    imageLoadFailed: '画像の読み込みに失敗しました',
    missingId: '壁紙IDパラメータがありません',
    notFound: '壁紙が見つかりません',
    fetchDetailFailed: '壁紙詳細の取得に失敗しました',
    networkError: 'ネットワークエラーです。接続を確認して再試行してください',
    resolutionSwitched: '解像度を {resolution} に切り替えました',
    startDownload: '壁紙のダウンロードを開始',
    linkCopied: '画像リンクをクリップボードにコピーしました',
    setDesktopHint: '画像を右クリックして「デスクトップの背景に設定」を選択してください',
    alreadyFavorited: 'この壁紙はすでにお気に入りに追加されています',
    favoriteSuccess: '壁紙をお気に入りに追加しました',
    copyFailedManual: 'コピーに失敗しました。手動でコピーしてください',
    wechatShareHint: 'WeChatでスキャンして共有してください',
    shareLinkCopied: '共有リンクをコピーしました',
    sharePrefix: 'Bing壁紙：'
  },
  about: {
    title: 'Bing壁紙について',
    subtitle: '豊富な閲覧、フィルタリング、ダウンロード機能を備えた美しいBing壁紙ギャラリーサイトです。',
    timeline1Title: '各ページを改善',
    timeline2Title: '初版、基本レイアウト完成',
    timeline3Title: 'ページネーション表示バグを修正',
    timeline4Title: '全面リニューアル',
    timeline4Item1: '1. リストレイアウトを改善し、より美しくシンプルな操作を実現',
    timeline4Item2: '2. ページネーションバグを修正（バグに頼らなくなりました！）',
    timeline4Item3: '3. 多角的な壁紙フィルタリング：地域、解像度、年など',
    timeline4Item4: '4. フィルター年 のすべての壁紙をワンクリックで一括ダウンロード',
    frontendProject: 'フロントエンドプロジェクト：',
    backendProject: 'バックエンドプロジェクト：',
    backendTutorial: 'バックエンドチュートリアル：',
    selfBuildApi: '自作Bing API',
    postPara1: 'バックエンドはドキュメントデータベース{link}MongoDB{/link}でデータを保存、無制限のCI/CDツール{link2}GitHub Actions{/link2}で毎日の壁紙データを取得してMongoDBに保存、Python高性能非同期フレームワーク{link3}FastAPI{/link3}をバックエンドに使用し、{link4}Vercel{/link4}でサーバーレスリクエスト処理を実現。フロントエンドは{link5}Element UI{/link5}フレームワークで迅速に開発。',
    postPara2: '最初にBing壁紙に出会った時、Bingで素晴らしい壁紙をたくさん見て、ブログの背景画像用のAPIが欲しいと思いました。その後、自分でAPIを構築する方法も学びました。道のりでは多くのことを学びました：Pythonのpymongoライブラリの使用、FastAPIの構築、Pythonのモジュラー設計、フロントエンドではナビゲーションレイアウト、アイコンライブラリの統合、vue-routerの使用、axiosリクエストのラッピング、ページネーションの読み込みなどです。',
    postPara3: '多くの困難もありました。Bing壁紙APIが地域別に対応できることを多くの資料を調べて見つけましたが、中国地域は強制リダイレクトされていました。Vercelでフロントエンドとバックエンドを同時に配置するリクエスト方法の解決にも長時間かかりました。FastAPIにも多くの落とし穴がありました。Pythonのモジュラー設計を完成させるために長時間の調査と他の人の設計の研究が必要でした。{link}Element UI{/link}を何度も読み返し、多くのバグに遭遇し、公式例に従ってvue-routerを理解し、ページネーションには未解決のバグがありました。PS：このバグは削除できません。プロジェクトはこのバグの上で動いています。',
    postPara4: '{strong}AI{/strong}は本当に素晴らしいです！！！',
    postPara5: '現在、bing-wallpaperは{link}Twikoo{/link}コメントシステムを統合しています。ご意見があればぜひコメントしてください！'
  },
  seo: {
    siteName: 'Bing壁紙',
    defaultTitle: 'Bing壁紙 | デイリーHD壁紙 | 世界中の壁紙をダウンロード',
    defaultDescription: 'Bing壁紙ダウンロードサイト。Microsoft BingのデイリーHD壁紙を提供し、多地域・多解像度の閲覧とダウンロードに対応。',
    homeTitle: 'Bing壁紙 | デイリーHD壁紙 | 世界中の壁紙をダウンロード',
    homeDescription: 'Bing壁紙ダウンロードサイト。Microsoft BingのデイリーHD壁紙を提供し、中国、アメリカ、日本、ドイツ、イギリス、フランス、イタリア、カナダ、インドなど9つの地域に対応。4K、1920x1080などの解像度で、年間壁紙の一括ダウンロードに対応。',
    regionTitle: '地域別Bing壁紙',
    regionDescription: '各地域のBingデイリーHD壁紙を閲覧・ダウンロード。中国、アメリカ、日本、ドイツ、イギリス、フランス、イタリア、カナダ、インドなどに対応。',
    aboutTitle: 'について',
    aboutDescription: 'Bing壁紙サイトの紹介。Microsoft BingのデイリーHD壁紙ダウンロードを提供し、多地域・多解像度の閲覧とダウンロードに対応。当サイトの画像はすべてBing検索からのものです。学習および個人使用のみに限定されています。',
    detailTitle: '壁紙詳細',
    detailDescription: 'Bing壁紙の詳細ページ。HD壁紙を閲覧し、複数の解像度でのダウンロードに対応。',
    regionSeoTitle: '{name} Bing壁紙 - {name}デイリーHD壁紙ダウンロード',
    regionSeoDesc: '{name} Bing壁紙ダウンロード。Microsoft Bing {name}地域のデイリーHD壁紙を提供し、4K、1920x1080などの解像度に対応。無料HDデスクトップ壁紙ダウンロード。',
    regionSeoKeywords: '{name} Bing壁紙,{name}壁紙,Bing壁紙,HD壁紙ダウンロード',
    detailSeoTitle: '{title} - {region} Bing壁紙HDダウンロード',
    detailSeoDesc: '{title}。{copyright} 公開日：{date}{region}。Bing壁紙は4K、1920x1080などの解像度で無料ダウンロードを提供。',
    detailSeoKeywords: '{title},{region} Bing壁紙,HD壁紙ダウンロード,bing wallpaper,{date}',
    detailSeoKeywordsNoRegion: '{title},Bing壁紙,HD壁紙ダウンロード,bing wallpaper,{date}',
    detailSeoTitleNoRegion: '{title} - Bing壁紙HDダウンロード',
    detailSeoFromRegion: '、{name}から',
    siteJsonLdDesc: 'Bing壁紙ダウンロードサイト。Microsoft BingのデイリーHD壁紙を提供し、多地域・多解像度の閲覧とダウンロードに対応。',
    regionJsonLdDesc: '{name}地域のBingデイリーHD壁紙ダウンロード。4K、1920x1080などの解像度に対応。',
    breadcrumbHome: 'ホーム',
    breadcrumbRegion: '{name} Bing壁紙',
    defaultKeywords: 'Bing壁紙,デイリー壁紙,HD壁紙ダウンロード,Microsoft Bing,Bing Wallpaper,HD壁紙,デスクトップ壁紙,4K壁紙,壁紙ダウンロード',
    htmlTitle: 'Bing壁紙 | デイリーHD壁紙 | 世界中の壁紙をダウンロード',
    htmlDescription: 'Bing壁紙ダウンロードサイト。Microsoft BingのデイリーHD壁紙を提供し、中国、アメリカ、日本、ドイツ、イギリス、フランス、イタリア、カナダ、インドなど9つの地域に対応。4K、1920x1080などの解像度で、年間壁紙の一括ダウンロードに対応。',
    htmlKeywords: 'Bing壁紙,デイリー壁紙,HD壁紙ダウンロード,Microsoft Bing,Bing Wallpaper,HD壁紙,デスクトップ壁紙,4K壁紙,壁紙ダウンロード,Bing壁紙API,壁紙コレクション,デイリー壁紙',
    htmlH1: 'Bing壁紙 - Microsoft Bing デイリーHD壁紙ダウンロード',
    htmlP: 'Bing壁紙ダウンロードサイト。Microsoft BingのデイリーHD壁紙を提供し、中国、アメリカ、日本、ドイツ、イギリス、フランスなど9つの地域のHD壁紙の閲覧とダウンロードに対応。4K、1920x1080などの解像度に対応し、年間壁紙の一括ダウンロードが可能です。',
    twitterTitle: 'Bing壁紙 | デイリーHD壁紙',
    twitterDesc: 'Microsoft BingのデイリーHD壁紙ダウンロード。多地域・多解像度に対応。'
  }
}



// WEBPACK FOOTER //
// ./src/locale/ja-JP.js